import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmMultipleChoiceComponent } from './sm-multiple-choice.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SmErrorModule } from '../sm-error/sm-error.module';



@NgModule({
  declarations: [SmMultipleChoiceComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SmErrorModule
  ],
  exports: [SmMultipleChoiceComponent]
})
export class SmMultipleChoiceModule { }
